export default "__VITE_ASSET__dx1yVRJs__"